import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import { documentTitles } from 'app/config/constants';

const getDocumentTitle = (pageTitle: any) => {
  return `${pageTitle} - HeyDoctor Clinic`;
};

export default function documentTitleCreate({ title, titleKey }: any) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [documentTitle, setDocumentTitle] = useState<string>();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const pageTitle = title || documentTitles[titleKey];
    const nextDocumentTitle = getDocumentTitle(pageTitle);
    if (documentTitle !== nextDocumentTitle) {
      setDocumentTitle(nextDocumentTitle);
    }
  });

  return <Helmet title={documentTitle} />;
}
